export default __webpack_public_path__ + "static/hotblack-events5-cd1145965cfaab6fe9fc076aa7341048.jpg";